/* eslint max-len:0 */
import get from 'lodash/get';
import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/fr';

export const translations = {
        en: {
            time: {
                days: 'days',
                hours: 'hours',
                minutes: 'minutes',
                seconds: 'seconds',
                shortDate: 'MM dd',
            },
            correct: 'CORRECT',
            wrong: 'WRONG',
            thanks: 'THANK YOU',
            hint: 'HINT',
            letterPool: {
                hintButtonText: 'Hint',
                jokerButtonText: 'Joker',
            },
            toPlaystore: 'Tap to continue to Google Play™',
            playstoreBadge: '//play.google.com/intl/en_us/badges/images/apps/en-play-badge-border.png',
            toPlaystoreLegal: 'Android, Google Play, and the Google Play logo are trademarks of Google Inc.',
            skipVideo: 'Continue',
            skipVideoTimer: 'Continue in {seconds}s',
            continueHeader: 'Continue',
            notAvailableAnymoreHeader: 'Sorry,',
            notAvailableAnymoreFooter: 'This offer is not available anymore. Please try again a bit later!',
            genericError: 'Sorry, there was an error. Please try again a bit later!',
            continueFooter: 'to the offer',
            loadingHeader: 'Redirecting.',
            loadingFooter: 'Please wait.',
            continueExplanation: 'Click/tap here if you aren\'t redirected automatically.',
            reengagement: {
                headerTitle: 'Your Missions',
                openAppButtonCaption: 'Open App',
                header: {
                    missed: 'Day {day}',
                    completed: 'Day {day}',
                    future: 'Day {day}',
                    today: 'Today',
                },
                footer: {
                    completed: 'earned',
                    missed: 'missed',
                }
            },
            rewardStatus: {
                PENDING: 'Under examination',
                CONFIRMED: 'Confirmed',
                REJECTED: 'Rejected',
                OBSOLETE: 'Successful',
            },
            statusOverview: {
                title: 'Your offers',
                contactButtonText: 'Report issue',
                reportButtonText: 'Report issue',
                imprintButtontext: 'Imprint',
                rewardWithLimit: 'up to {reward}',
                rewardsListEmpty: 'Nothing to see here yet! When you participate in offers, they will appear here.',
                userHasContactedSupportText: 'Processing request'
            },
            contactConfirmation: {
                title: 'Thanks for your feedback!',
                statusText: 'We will have a look on the issue.',
                greetingsText: 'Have fun! Your KWIZZAD team.',
                backToOfferButtonLabel: 'Return to the offer',
            },
            rewardFieldNames: {
                campaignName: 'Offer name',
                value: 'Reward',
                eventTimestamp: 'Started',
                averageDuration: 'Usual waiting time',
                reason: 'Reason',
            },
            contactForm: {
                title: 'Report issue',
                sendButtonLabel: 'Report issue',
                emailLabel: 'Email',
                emailPlaceholder: 'your.email@example.com',
                emailInvalid: 'Please correct ↓',
                emailMissing: 'Please enter ↓',
                commentMissing: 'Please enter ↓',
                commentLabel: 'Comment',
                commentPlaceholder: 'Here you can describe the problem you had.',
                screenShotLabel: 'Screenshot',
                imprintButtonLabel: 'Imprint',
            },
            imprint: {
                title: 'Imprint',
                court: 'Jurisdiction | Local Court Berlin-Charlottenburg',
                hrb: 'HRB 147786',
                ceos: 'Represented by (Geschäftsführer): Christian Heins & Jakob Börsch',
                vatNumber: 'Sales tax identification number corresponding § 27 a German Value-Added Tax Act (UStG): DE288544402',
                responsible: 'Concerning the contents person responsible according to §55 paragraph 2 RStV: Christian Heins (Address as above)',
            },
        },
        de: {
            time: {
                days: 'Tage',
                hours: 'Stunden',
                minutes: 'Minuten',
                seconds: 'Sekunden',
                shortDate: 'dd. MM ’YY',
            },
            correct: 'KORREKT',
            wrong: 'FALSCH',
            thanks: 'DANKE',
            hint: 'HINWEIS',
            letterPool: {
                hintButtonText: 'Hinweis',
                jokerButtonText: 'Joker',
            },
            toPlaystore: 'Tap und weiter geht\'s zu Google Play™',
            playstoreBadge: '//play.google.com/intl/en_us/badges/images/apps/de-play-badge-border.png',
            toPlaystoreLegal: 'Android, Google Play und das Google Play-Logo sind Marken von Google Inc.',
            skipVideo: 'Weiter',
            skipVideoTimer: 'Weiter in {seconds}s',
            continueHeader: 'Weiter',
            continueFooter: 'zum Angebot',
            notAvailableAnymoreHeader: 'Sorry,',
            notAvailableAnymoreFooter: 'Das Angebot ist nicht mehr verfügbar. Probier\'s später nochmal!',
            genericError: 'Sorry, es ist ein Fehler aufgetreten. Probier\'s später nochmal!' ,
            loadingHeader: 'Bitte warten.',
            loadingFooter: 'Du wirst weitergeleitet.',
            continueExplanation: 'Klicke/tippe hier, falls du nicht automatisch weitergeleitet wirst.',
            rewardStatus: {
                PENDING: 'In Prüfung',
                CONFIRMED: 'Erfolgreich',
                REJECTED: 'Abgelehnt',
                OBSOLETE: 'Erfolgreich',
            },
            reengagement: {
                headerTitle: 'Deine Missionen',
                openAppButtonCaption: 'App öffnen',
                completedStep: '{awardedPoints} smiles verdient',
                missedStep: '{awardedPoints} smiles verpasst',
                taskName: 'Mission für Tag {day}',
            },
            statusOverview: {
                title: 'Übersicht deiner Angebote',
                contactButtonText: 'Problem melden',
                reportButtonText: 'Problem melden',
                imprintButtontext: 'Impressum',
                rewardWithLimit: 'bis zu {reward}',
                rewardsListEmpty: 'Hier gibt\'s noch nichts zu sehen! Sobald du an Angeboten teilnimmst, findest du hier eine Übersicht.',
                userHasContactedSupportText: 'Anfrage in Bearbeitung'
            },
            contactConfirmation: {
                title: 'Vielen Dank für deine Nachricht!',
                statusText: 'Wir werden deine Anfrage prüfen.',
                greetingsText: 'Viel Spaß beim Weiterspielen! Dein KWIZZAD-Team.',
                backToOfferButtonLabel: 'Zurück zum Angebot',
            },
            rewardFieldNames: {
                campaignName: 'Angebotsname',
                value: 'Vergütung',
                eventTimestamp: 'Gestartet',
                averageDuration: 'Übliche Wartezeit',
                reason: 'Grund',
            },
            contactForm: {
                title: 'Problem melden',
                emailLabel: 'Email',
                emailPlaceholder: 'deine.email@example.com',
                commentLabel: 'Kommentar',
                commentPlaceholder: 'Hier kannst du das das Problem beschreiben.',
                screenShotLabel: 'Screenshot',
                sendButtonLabel: 'Problem melden',
                imprintButtonLabel: 'Impressum',
                emailInvalid: 'Bitte korrigieren ↓',
                emailMissing: 'Bitte ausfüllen ↓',
                commentMissing: 'Bitte ausfüllen ↓',
            },
            imprint: {
                title: 'Impressum',
                court: 'Registergericht Berlin-Charlottenburg',
                hrb: 'HRB 147786',
                ceos: 'Geschäftsführung: Christian Heins & Jakob Börsch',
                vatNumber: 'Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE288544402',
                responsible: 'Inhaltlich Verantwortlicher gemäß § 55 Abs. 2 RStV: Christian Heins (Anschrift wie oben)',
            },
        },
        fr: {
            time: {
                days: 'jours',
                hours: 'heures',
                minutes: 'minutes',
                seconds: 'secondes',
            },
            correct: 'CORRECT',
            wrong: 'FAUX',
            thanks: 'MERCI',
            hint: 'INDICE',
            letterPool: {
                hintButtonText: 'Indice',
                jokerButtonText: 'Joker',
            },
            toPlaystore: 'Tapper pour continuer a Google Play™',
            playstoreBadge: '//play.google.com/intl/en_us/badges/images/apps/en-play-badge-border.png',
            toPlaystoreLegal: 'Android, Google Play, and the Google Play logo are trademarks of Google Inc.',
            skipVideo: 'Continue',
            skipVideoTimer: 'Continue dans {seconds}s',
            continueHeader: 'Continue',
            notAvailableAnymoreHeader: 'Désolé,',
            notAvailableAnymoreFooter: 'Cette offre n\'est pas disponible ence moment. S\'il vous plait essayer un peu plus tard !',
            genericError: 'Désolé, il y avait une erreur. S\'il vous plait essayer un peu plus tard !',
            continueFooter: 'à l\'offre',
            loadingHeader: 'Redirection.',
            loadingFooter: 'Patientez un peu.',
            continueExplanation: 'Cliquer/Tapper ici si vous n\'etes pasredigé automatiquement.',
            reengagement: {
                headerTitle: 'Votre Missions',
                openAppButtonCaption: 'Ouvrir l’appli',
                completedStep: '{awardedPoints} smiles fini',
                missedStep: '{awardedPoints} smiles ratée',
                taskName: 'Jour {day}',
            },
            rewardStatus: {
                PENDING: 'En examination',
                CONFIRMED: 'Confirmé',
                REJECTED: 'Rejeté',
                OBSOLETE: 'Succés',
            },
            statusOverview: {
                title: 'Vos offres',
                contactButtonText: 'Reporter un problème',
                reportButtonText: 'Reporter un problème',
                imprintButtontext: 'Imprint',
                rewardWithLimit: 'jusqua { reward }',
                rewardsListEmpty: 'Rien à voir ici. Lorsque vous participer à des offres, elles seront affiché ici.',
                userHasContactedSupportText: 'Requête en traitement'
            },
            contactConfirmation: {
                title: 'Merci pour votre avis !',
                statusText: 'Nous allons examiner le problème.',
                greetingsText: 'Amusez vous ! L\'équipe de Kwizzad',
                backToOfferButtonLabel: 'Retourner à l\'offre',
            },
            rewardFieldNames: {
                campaignName: 'nom de l\'offre',
                value: 'Récompense',
                eventTimestamp: 'Démarré',
                averageDuration: 'Temps d\'attente normale',
                reason: 'Reason',
            },
            contactForm: {
                title: 'Reporter un problème',
                sendButtonLabel: 'Reporter un problème',
                emailLabel: 'Email',
                emailPlaceholder: 'votre.email@example.com',
                emailInvalid: 'S\'il vous plait corriger â ↓',
                emailMissing: 'S\'il vous plait entrer â ↓',
                commentMissing: 'S\' il vous plait entrer â ↓',
                commentLabel: 'Commentaire',
                commentPlaceholder: 'Ici vous pouvez décrire votre problème.',
                screenShotLabel: 'Capture d\'écran',
                imprintButtonLabel: 'Imprint',
            },
            imprint: {
                title: 'Imprint',
                court: 'Jurisdiction | Local Court Berlin-Charlottenburg',
                hrb: 'HRB 147786',
                ceos: 'Representé par (Geschäftsführer) : Christian Heins & Jakob Börsch',
                vatNumber: 'Sales tax identification number corresponding §27 a German Value-Added Tax Act (UStG): DE288544402',
                responsible: 'Concerning the contents person responsible according to §55 paragraph 2 RStV: Christian Heins (Address as above)',
            },
        },
    }
    ;

export let currentLocale = 'en';
const supportedLanguages = Object.keys(translations);

export function translate(stringName, options = {}) {
    const localizedTranslations = (translations[currentLocale || 'en'] || translations.en);
    let string = get(localizedTranslations, stringName);
    if (!string) {
        return null;
    }
    if (typeof string !== 'string') {
        console.error('String for', stringName, 'has invalid class.');
        return null;
    }
    string = string.replace(/\{[a-zA-Z1-9]+\}/g, keyWithCurlyBraces => {
        const key = keyWithCurlyBraces.replace(/{/, '').replace('}', '');
        return options[key] || keyWithCurlyBraces;
    });
    return string;
}

export function setLocale(locale) {
    if (supportedLanguages.indexOf(locale) === -1) {
        locale = 'en';
    }
    currentLocale = locale;
    moment.locale(locale);
}

export const t = translate;

// moment.locale('de', {
//     relativeTime: {
//         future: 'in %s',
//         past: 'vor %s',
//         s: 'Sekunden',
//         m: 'eine Minute',
//         mm: '%d Minuten',
//         h: 'eine Stunde',
//         hh: '%d Stunden',
//         d: 'ein Tag',
//         dd: '%d Tagen',
//         M: 'ein Monat',
//         MM: '%d Monaten',
//         y: 'ein Jahr',
//         yy: '%d Jahren',
//     },
// });



// WEBPACK FOOTER //
// ./src/lib/i18n.jsx